import React, { useMemo, useRef } from 'react';
import jsonpath from 'jsonpath';
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const PokaYokeSheet = ({ obj, data, company }) => {
  const keys = Object.keys(data);
  const customerRef = useRef([]);
  const daysInMonth = getDaysInCurrentMonth();
  const daysInMonthArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  function extractData(json, path) {
    return json ? jsonpath.query(json, path) : '';
  }
  function getCustomFieldValue(obj, targetFieldName) {
    const results = [];
  
    function recurse(node) {
      if (Array.isArray(node)) {
        node.forEach(recurse);
      } else if (node && typeof node === 'object') {
        if (Array.isArray(node.customFields)) {
          node.customFields.forEach(field => {
            if (field.FieldName === targetFieldName) {
              results.push(field.Value);
            }
          });
        }
  
        Object.values(node).forEach(recurse);
      }
    }
  
    recurse(obj);
    return results;
  }
  
  function getDaysInCurrentMonth() {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  }

  const demoFromHTML = async (key) => {
    const source = customerRef.current[key];

    const loadImages = () => {
      const images = source.getElementsByTagName('img');
      return Promise.all(
        Array.from(images).map(
          (img) =>
            new Promise((resolve) => {
              img.complete ? resolve() : (img.onload = img.onerror = resolve);
            })
        )
      );
    };

    await loadImages();
    const table = source.querySelector('table');
    const rows = Array.from(table.querySelectorAll('tr'));
    const maxRowsPerPage = 25;
    const totalRows = rows.length;
    const numPages = Math.ceil(totalRows / maxRowsPerPage);

    const pdf = new jsPDF('landscape', 'pt', 'a4',true);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const margin = 20;
    const availableWidth = pdfWidth - 2 * margin;
    const availableHeight = pdfHeight - 2 * margin;

    for (let page = 0; page < numPages; page++) {
      const startRow = page * maxRowsPerPage;
      const endRow = Math.min((page + 1) * maxRowsPerPage, totalRows);
      rows.forEach((row, i) => {
        row.style.display = i >= startRow && i < endRow ? '' : 'none';
      });

      const canvas = await html2canvas(source, { scale: 2 });
      const imgData = canvas.toDataURL('image/jpeg', 0.7);
      const imgHeight = (canvas.height * availableWidth) / canvas.width;

      pdf.addImage(imgData, 'JPEG', margin, margin, availableWidth, Math.min(imgHeight, availableHeight));
      if (page < numPages - 1) pdf.addPage();
    }

    rows.forEach((row) => (row.style.display = ''));
    pdf.save(`${obj.InspectionType}_${new Date(obj.DateTime).toLocaleString()}.pdf`);
  };

  const getShiftDataForType = (data, pdf, rowIndex, eventType) => {
    return daysInMonthArray.map((day) => {
      const shiftData = data?.[pdf]?.find((item) => {
        const shiftDate = (getCustomFieldValue(item, 'Date_Shift')[0] || '')
        // extractData(item, '$..customFields[?(@.FieldName=="Date_Shift")].Value')[0];
        const shiftEvent = (getCustomFieldValue(item, 'Shift Event')[0] || '')
        // extractData(item, '$..customFields[?(@.FieldName=="Shift Event")].Value')[0];
        return shiftEvent === eventType && new Date(shiftDate).getDate() === day;
      });

      const result = shiftData?.Checksheet?.[rowIndex]?.Data?.[0]?.ResultLabel ??
        shiftData?.Checksheet?.[rowIndex]?.Data?.[0]?.Result ?? '-';

      return (
        <th key={day} style={{ verticalAlign: 'middle' }}>
          {shiftData ? result : '-'}
        </th>
      );
    });
  };

  const dateHeaders = useMemo(() => (
    Array.from({ length: daysInMonth }, (_, index) => <th key={index}>{index + 1}</th>)
  ), [daysInMonth]);
  
  const renderShiftTimes = (data, pdf, shiftEvent) =>
    daysInMonthArray.map((day) => {
    const shiftData = Object.values(data?.[pdf] || {}).find((item) => {
  const shiftDate = (getCustomFieldValue(item, 'Date_Shift')[0] || '');
  const eventVal = (getCustomFieldValue(item, 'Shift Event')[0] || '');
  return eventVal === shiftEvent && new Date(shiftDate).getDate() === day;
});


      return (
        <th key={day} className="text-wrap text-center" style={{ verticalAlign: 'middle' }}>
          {shiftData?.DateTime ? moment(shiftData.DateTime).format('hh:mm a') : '-'}
        </th>
      );
    });

  // const getEndOfShiftDataForDay = (data, pdf, rowIndex) =>
  //   daysInMonthArray.map((day, index) => {
  //     const endData = data?.[pdf]?.find((item) => {
  //       const shiftDate = extractData(item, '$..customFields[?(@.FieldName=="Date_Shift")].Value')[0];
  //       const event = extractData(item, '$..customFields[?(@.FieldName=="Shift Event")].Value')[0];
  //       return event === 'End Of Shift' && new Date(shiftDate).getDate() === day;
  //     });

  //     const result =
  //       endData?.Checksheet?.[rowIndex]?.Data?.[0]?.ResultLabel ??
  //       endData?.Checksheet?.[rowIndex]?.Data?.[0]?.Result ??
  //       '-';

  //     return (
  //       <th key={index} style={{ verticalAlign: 'middle' }}>
  //         {endData ? result : '-'}
  //       </th>
  //     );
  //   });

  // const renderDays = (dataArray, pdf, shiftEvent) =>
  //   daysInMonthArray.map((day, index) => {
  //     const shiftData = data?.[pdf]?.find((item) => {
  //       const shiftDate = extractData(item, '$..customFields[?(@.FieldName=="Date_Shift")].Value')[0];
  //       const eventVal = extractData(item, '$..customFields[?(@.FieldName=="Shift Event")].Value')[0];
  //       return eventVal === shiftEvent && new Date(shiftDate).getDate() === day;
  //     });

  //     return (
  //       <th key={index} className="text-wrap text-center" style={{ verticalAlign: 'middle' }}>
  //         {shiftData?.DateTime ? moment(shiftData.DateTime).format('hh:mm a') : '-'}
  //       </th>
  //     );
  //   });

  return (
    <>
      {keys.sort((a, b) => a.localeCompare(b)).map((pdf, tableIndex) => {
         const startOfShift = renderShiftTimes(data, pdf, 'Start Of Shift');
         const endtOfShift = renderShiftTimes(data, pdf, 'Start Of Shift');

        return (
        <div key={tableIndex}>
          <button className="btn-sm btn-primary" onClick={() => demoFromHTML(tableIndex)}>
            Download PDF
          </button>
          <div className='table-responsive' ref={(el) => (customerRef.current[tableIndex] = el)}>
            <table className="table table-sm table-bordered table-hover small table-striped" style={{ padding: 0 }}>
              <thead className="small text-center border">
                <tr className="text-center align-self-center">
                  <th className="text-start fs-5" style={{ verticalAlign: 'middle' }} colSpan={4}>
                    <img src={company.logo || ''} className="avatar" style={{ width: 150 }} />
                  </th>
                  <th style={{ verticalAlign: 'middle' }} colSpan={daysInMonth - 4}>
                  {getCustomFieldValue(obj, 'Line Number')[0] || ''}
                    {/* {extractData(obj, '$..customFields[?(@.FieldName=="Line Number")].Value')} */}
                  </th>
                  <th style={{ verticalAlign: 'middle' }} colSpan={8}>
                    MONTH - {obj.DateTime ? moment(obj.DateTime).format('MMM , YYYY') : '-'} {' / shift :' + pdf}
                  </th>
                </tr>
                <tr className="text-center align-self-center">
                  <th style={{ verticalAlign: 'middle' }} rowSpan={4}>
                    Poka Yoke No.
                  </th>
                  <th style={{ verticalAlign: 'middle' }} rowSpan={4}>
                    M/C Name & No.
                  </th>
                  <th style={{ verticalAlign: 'middle' }} rowSpan={4}>
                    Poka Yoke Type
                  </th>
                  <th style={{ verticalAlign: 'middle' }} rowSpan={4}>
                    Purpose
                  </th>
                  <th style={{ verticalAlign: 'middle' }} rowSpan={4}>
                    How to Check
                  </th>
                  <th style={{ verticalAlign: 'middle' }} rowSpan={4}>
                    Checking Point
                  </th>
                  <th style={{ verticalAlign: 'middle' }}></th>
                  <th style={{ verticalAlign: 'middle' }} colSpan={daysInMonth}>
                    DATE
                  </th>
                </tr>
                        <tr className='text-center align-self-center '>
                        <th style={{ verticalAlign: 'middle' }} rowSpan={1} ></th>
                        {/*  to render dates in a month  */}
                        {dateHeaders}

                        </tr>
                        <tr className='text-center align-self-center '>
                        <th style={{ verticalAlign: 'middle' }} rowSpan={1} >Start Of Shift (time)</th>
                        {/* {renderShiftTimes(data, pdf, 'Start Of Shift')} */}
                        {startOfShift}
                        </tr>
                        <tr  className='text-center align-self-center '>
                        <th style={{ verticalAlign: 'middle' }} rowSpan={1} >End Of Shift (time)</th>
                        {/* {renderShiftTimes(data, pdf, 'End Of Shift')} */}
                          {endtOfShift}
                        </tr>
                        
                    </thead>
                    <tbody>
                        {data[pdf] && data[pdf].length > 0 && data[pdf][0].Checksheet.map((one, rowIndex) => (
                            <React.Fragment key={rowIndex}>
                                <tr>
                                   <th rowSpan={2} style={{ fontWeight: '400' }} className="text-center">{one.Poka_Yoke_No}</th>
                                    <th rowSpan={2} style={{ fontWeight: '400' }} className="text-center">{one.MC_Name__No}</th>
                                    <th rowSpan={2} style={{ fontWeight: '400' }} className="text-center">{one.PokaYoke_Type}</th>
                                    <th rowSpan={2} style={{ fontWeight: '400' }} className="text-center">{one.Purpose}</th>
                                    <th rowSpan={2} className="text-center" style={{ fontWeight: '400' }}>{one.How_To_Check}</th>
                                    <th rowSpan={2} className="text-center" style={{ fontWeight: '400' }}>{one.Checking_Point}</th>
                                 {/* Start of Shift */}
                                 <th rowSpan={1} className="text-center" style={{ fontWeight: '400' }}>Start of Shift</th>
                                 {getShiftDataForType(data, pdf, rowIndex, 'Start Of Shift')}
                              
                            </tr>
                                {/* End of Shift */}
                                <tr>
                                    <th rowSpan={1} className="text-center" style={{ fontWeight: '400' }}>End Of Shift</th>
                                    {getShiftDataForType(data, pdf, rowIndex, 'End Of Shift')}
                                   
                                    
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                    <tfoot className='small text-center border'>
                        <tr className='text-center align-self-center '>
                            <td style={{ verticalAlign: 'middle' }} className='text-center ' colSpan={6}>Sign (Q.A)</td>
                            <td style={{ verticalAlign: 'middle' }} colSpan={32}>
                              {/* {extractData(obj, '$..customFields[?(@.FieldName=="QA Personnel")].Value')} */}
                              {getCustomFieldValue(obj, 'QA Personnel')[0] || ''}
                              </td>
                        </tr>
                        <tr className='text-center align-self-center '>
                            <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={3}>U/I Under Implementation</td>
                            <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={2}>NP: No Production</td>
                            <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={1}>OK</td>
                            <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={1}>Not Ok </td>
                            <td style={{ verticalAlign: 'middle' }} colSpan={31}> Note :- Poka yoke need to verified during Petrol Inspection</td>
                        </tr>
                        <tr className='text-center align-self-center '>
                            <td style={{ verticalAlign: 'middle' }} colSpan={2}> Note </td>
                            <td className="text-start" colSpan={31 + 5}> 1. Poka yoke need to verified during Petrol Inspection <br />
                                2. If Poka-Yoke not working stop the machine and inform to supervisor <br />
                                3. Incase of line run without poka-yoke, deviation will be raise and get it approval from Quality Head / Plant Manager and additional control to be implemente.
                            </td>
                        </tr>
                         <tr className='text-center align-self-center '>
                        
                        <td className='text-start' colSpan={38}>FMT-QAD-47, Rev-0 Dated-28-05-2014</td>
                    
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>)})}
                        </>
    )
}
export default PokaYokeSheet